import { Page } from '@bonanza-social/navigation';
import AllGames from '../components/AllGames/AllGames';
import useGames from '../hooks/useGames';

function AllGamesPage() {
  useGames();

  return (
    <Page>
      <AllGames />
    </Page>
  );
}

export default AllGamesPage;
